// ConfirmModal.jsx
import React from "react";
import ReactDOM from "react-dom";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmation",
  message,
  selectedNames = [],
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "backButton", 
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          minWidth: 300,
          width: "33%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        <h4 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
          {title}
        </h4>
        <p>{message}</p>
        {selectedNames.length > 0 && (
          <ul className="list-disc ml-5 text-gray-700 text-sm max-h-40 overflow-y-auto mt-2">
            {selectedNames.map((name, i) => (
              <li key={i}>{name}</li>
            ))}
          </ul>
        )}
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="saveButton"
            onMouseDown={(e) => e.preventDefault()}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={confirmColor}
            onMouseDown={(e) => e.preventDefault()}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
